import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import UsageCard from './components/UsageCard';

import styles from './styles/Usage';
const useStyles = createUseStyles(styles, 'Usage');

const Usage = memo(({ schema, locale = 'en', onHover, linkCallback }) => {
    const classes = useStyles();

    const cards = useMemo(() => {
        return schema?.length
            ? schema.map((card, index) => (
                  <UsageCard
                      key={index}
                      locale={locale}
                      onHover={onHover}
                      linkCallback={linkCallback}
                      {...card}
                  />
              ))
            : [];
    }, [schema, locale, onHover, linkCallback]);

    return cards.length ? <section className={classes.root}>{cards}</section> : null;
});

Usage.propTypes = {
    locale: PropTypes.string,
    onHover: PropTypes.func,
    schema: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            icon: PropTypes.string,
            progress: PropTypes.shape({
                value: PropTypes.number,
                max: PropTypes.number,
            }),
            progressCustomFormat: PropTypes.func,
            info: PropTypes.shape({
                text: PropTypes.string,
                cta: PropTypes.arrayOf(
                    PropTypes.shape({
                        type: PropTypes.oneOf(['primary', 'secondary']),
                        text: PropTypes.string,
                        onClick: PropTypes.func,
                    }),
                ),
            }),
        }),
    ).isRequired,
    linkCallback: PropTypes.func,
};

export default Usage;
